import LegalBlock, { LegalBlockProps } from './LegalBlock';

export type { LegalBlockProps };
export default LegalBlock;
